import React, { useState } from "react";
import {
  Box,
  CssBaseline,
  AppBar,
  Toolbar,
  Typography,
  Container,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ConfirmationDialog from "./ConfirmationDialog";
import { useAuth } from "../contexts/AuthContext";
import { Outlet, Link } from "react-router-dom";

const Layout = ({ title, linkToNavigate }) => {
  const { logout, user } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const confirmLogout = () => {
    setShowLogoutDialog(false);
    logout();
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <CssBaseline />

      {/* AppBar for Page Title */}
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Typography
            variant="h6"
            noWrap
            component={Link}
            to={linkToNavigate}
            sx={{
              textDecoration: "none",
              color: "inherit",
              flexGrow: 1,
              textAlign: "left",
            }}
          >
            {title}
          </Typography>

          <IconButton
            onClick={handleMenuOpen}
            color="inherit"
            size="large"
            aria-label="user menu"
            aria-controls="account-menu"
          >
            <AccountCircleIcon />
          </IconButton>

          {/* Dropdown Menu */}
          <Menu
            id="account-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            sx={{
              "& .MuiPaper-root": {
                maxWidth: { xs: "90%", sm: "300px", md: "400px" },
                minWidth: "200px",
              },
            }}
          >
            <MenuItem
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                whiteSpace: "normal",
              }}
            >
              <AccountCircleIcon />
              <Typography
                variant="body1"
                sx={{
                  flexGrow: 1,
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                }}
              >
                {user?.name || "User"}
              </Typography>
            </MenuItem>
            <MenuItem onClick={() => setShowLogoutDialog(true)}>
              <LogoutIcon sx={{ mr: 1 }} />
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: { xs: 2, sm: 3 },
          mt: { xs: 8, sm: 8 }, // Accounts for AppBar height
          minHeight: "auto", // Removes unnecessary minHeight
        }}
      >
        <Container maxWidth="lg">
          <Outlet />
        </Container>
      </Box>

      {/* Confirmation Dialog for Logout */}
      <ConfirmationDialog
        open={showLogoutDialog}
        onClose={() => setShowLogoutDialog(false)}
        onConfirm={confirmLogout}
        title="Logout Confirmation"
        message="Are you sure you want to logout?"
        confirmButtonText="Logout"
      />
    </Box>
  );
};

export default Layout;
